// import { useEffect, useState } from "react";
// import { useQuery } from "react-query";
// import Select from "react-select";
// import { getAddsOne, getAddsOneGroup } from "../../../MyApi/addsone";
// import LoadingSpinner from "../../UI/spinner";
// import AddsOneModal from "./addsoneModal";
// const AddsOne = ({ setAddsOns, add_ons, mode ,store_id ,selectedAddsOns  ,setSelectedAddsOns }) => {

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const { data, isLoading, refetch } = useQuery(["getAddsonegroup",store_id], ()=>getAddsOneGroup(store_id ));
//   const addsOne = data?.data?.add_on_groups || [];

//   useEffect(() => {
//     if ((!add_ons?.length || !addsOne?.length) ) return;

//     const selected = addsOne.filter((option) => add_ons.includes(option.id));
//     console.log("selected", selected);
//     console.log("selectedAddsOns", selectedAddsOns);
//     setSelectedAddsOns(selected);
//   }, [add_ons, addsOne]);
//   console.log('add_ons', add_ons)
//   const openModal = () => {
//     setIsModalOpen(true);
//   };
//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   return (
//     <div>
//       <div className="d-flex justify-content-between align-items-center add table mb-3">
//         <h6> مجموعة الإضافات</h6>
//         <button type="button" className="btn btn-primary" onClick={openModal}>
//           إضافة إضافات +
//         </button>
//       </div>
//      {isLoading? <LoadingSpinner/>: <div>

//         <Select
//           isMulti
//           isDisabled={isLoading}
//           options={addsOne}
//           getOptionLabel={(e) => e.name}
//           getOptionValue={(e) => e.id}
//           value={selectedAddsOns}
//           onChange={(selectedOption) => {
//             setAddsOns(selectedOption.map((add) => add.id));
//             setSelectedAddsOns(selectedOption);
//           }}
//         ></Select>
//       </div>}

//       {addsOne.map((add_on)=><div key={add_on} className="mt-2">
//             { add_on.add_ons.map((add)=><div key={add.id}>  <label htmlFor="">{add.name}</label>  <input type="number" className="form-control" placeholder="السعر" value={add.price} /></div>)}
//         </div>)}
//       <AddsOneModal
//         refetch={refetch}
//         closeModal={closeModal}
//         isOpen={isModalOpen}
//         store_id={store_id}
//       />
//     </div>
//   );
// };

// export default AddsOne;

import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import Select from "react-select";
import { getAddsOneGroup } from "../../../MyApi/addsone";
import LoadingSpinner from "../../UI/spinner";
import AddsOneModal from "./addsoneModal";
import { formatPrice } from "../../../utils/formatPrice";
import DeleteIcon from "../../Common/svg/deleteicon";

const AddsOne = ({
  setAddsOns,
  add_ons,
  store_id,
  selectedAddsOns,
  setSelectedAddsOns,
  setAddsOnsPayload,
  groupsState,
  setGroupsState,
  setSelectedAddOnsGroup,
  selectedAddOnsGroup,
  product,
  mode
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // editable state for groups

  useEffect(() => {
    const newPayload = {
      add_on_groups: Object.keys(groupsState).map((groupId) => ({
        id: Number(groupId),
        selection_type: groupsState[groupId].selection_type,
        min_selections: Number(groupsState[groupId].min_selections),
        max_selections: Number(groupsState[groupId].max_selections),
        add_ons: groupsState[groupId].add_ons
          .filter((a) => a.selected)
          .map((a) => ({
            id: a.id,
            price: Number(a.price),
            is_default: a.is_default,
          })),
      })),
    };

    setAddsOnsPayload(newPayload);
  }, [groupsState]);
  const { data, isLoading, refetch } = useQuery(
    ["getAddsonegroup", store_id],
    () => getAddsOneGroup(store_id),
  );

  const addOnGroups = data?.data?.add_on_groups || [];

  // useEffect(() => {
  // if (!addOnGroups.length || !add_ons?.length) return;

  //   const initialState = {};

  //   selectedAddsOns.forEach((group) => {
  //     initialState[group.id] = {
  //       selection_type: group.selection_type|| "single",
  //       min_selections: group.min_selections ||1,
  //       max_selections: group.max_selections ||1,
  //       add_ons: group.add_ons.map((a) => ({
  //         id: a.id,
  //         name: a.name,
  //         price: product?.currency_factor ?  formatPrice(product.currency_factor, a.price) : a.price,
  //         is_default: a.is_default == 1 ? 1 : 0,
  //       })),
  //     };
  //   });

  //   setGroupsState(initialState);
  // }, [ data ,add_ons]);

useEffect(() => {
  if (!addOnGroups.length) return;

  setGroupsState((prev) => {
    const newState = {};

    selectedAddsOns.forEach((selGroup) => {
      const apiGroup = addOnGroups.find((g) => g.id === selGroup.id);
      if (!apiGroup) return;

      // keep existing edits (price, is_default, selected, etc.) if already present
      if (prev[apiGroup.id]) {
        newState[apiGroup.id] = prev[apiGroup.id];
        return;
      }

      const selectedGroup = selGroup;

      newState[apiGroup.id] = {
        selection_type:
          selectedGroup?.selection_type ||
          apiGroup.selection_type ||
          "single",

        min_selections:
          selectedGroup?.min_selections ?? apiGroup.min_selections ?? 1,

        max_selections:
          selectedGroup?.max_selections ?? apiGroup.max_selections ?? 1,

        add_ons: apiGroup.add_ons.map((addon) => {
          const isSelected = selectedGroup?.add_ons?.some(
            (a) => a.id === addon.id,
          );

          const selectedAddon = selectedGroup?.add_ons?.find(
            (a) => a.id === addon.id,
          );

          return {
            id: addon.id,
            name: addon.name,
            selected: !!isSelected,
            price: product?.currency_factor
              ? formatPrice(
                  product.currency_factor,
                  selectedAddon?.price ?? addon.price,
                )
              : (selectedAddon?.price ?? addon.price),
            is_default: selectedAddon?.is_default == 1 ? 1 : 0,
          };
        }),
      };
    });

    return newState; // only groups still in selectedAddsOns survive
  });
}, [addOnGroups, selectedAddsOns, data]);




  const updateGroupField = (groupId, field, value) => {
    setGroupsState((prev) => ({
      ...prev,
      [groupId]: {
        ...prev[groupId],
        [field]: value,
      },
    }));
  };

  const updateAddon = (groupId, addonId, field, value) => {
    setGroupsState((prev) => ({
      ...prev,
      [groupId]: {
        ...prev[groupId],
        add_ons: prev[groupId].add_ons.map((a) =>
          a.id === addonId ? { ...a, [field]: value } : a,
        ),
      },
    }));
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const toggleAddon = (groupId, addonId, field, value) => {
    
  
    setGroupsState((prev) => ({
    ...prev,
    [groupId]: {
      ...prev[groupId],
      add_ons: prev[groupId].add_ons.map((a) =>
        a.id === addonId ? { ...a, [field]: value } : a
      ),
    },
  }));
  
  };
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6>مجموعة الإضافات</h6>

        <button className="btn btn-primary" type="button" onClick={openModal}>
          إضافة إضافات +
        </button>
      </div>

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Select
          isMulti
          options={addOnGroups}
          getOptionLabel={(e) => e.name}
          getOptionValue={(e) => e.id}
          value={selectedAddsOns}
          onChange={(selectedOption) => {
            setSelectedAddsOns(selectedOption);
            setAddsOns(selectedOption.map((g) => g.id));
            setSelectedAddOnsGroup(selectedOption);
            if (!selectedOption || selectedOption.length === 0) {
              setGroupsState({}); // <-- reset groupsState
            } else {
              // optionally, keep previous logic for new selections
              const newState = {};
              selectedOption.forEach((group) => {
                newState[group.id] = groupsState[group.id] || {
                  selection_type: group.selection_type || "single",
                  min_selections: group.min_selections || 1,
                  max_selections: group.max_selections || 1,
                  add_ons: group.add_ons.map((a) => ({
                    id: a.id,
                    name: a.name,
                    selected: true,
                    price: formatPrice(product.currency_factor, a.price),
                    is_default: a.is_default,
                  })),
                };
              });
              setGroupsState(newState);
            }
          }}
        />
      )}

      {selectedAddsOns?.map((group) => {
        const groupState = groupsState[group.id];
        if (!groupState) return null;

        return (
          <div key={group.id} className="border p-3 rounded mt-3">
            <h6>{group.name}</h6>

            {/* group settings */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label>نوع الاختيار</label>
                <select
                  className="form-control"
                  value={groupState.selection_type}
                  onChange={(e) =>
                    updateGroupField(group.id, "selection_type", e.target.value)
                  }
                >
                  <option value="single">فردي</option>
                  <option value="multiple">متعدد</option>
                </select>
              </div>

              <div className="col-md-4">
                <label>الحد الأدنى للاختيار</label>
                <input
                  type="number"
                  className="form-control"
                  value={groupState.min_selections}
                  onChange={(e) =>
                    updateGroupField(group.id, "min_selections", e.target.value)
                  }
                />
              </div>

              <div className="col-md-4">
                <label>الحد الأقصى للاختيار</label>
                <input
                  type="number"
                  className="form-control"
                  value={groupState.max_selections}
                  onChange={(e) =>
                    updateGroupField(group.id, "max_selections", e.target.value)
                  }
                />
              </div>
            </div>

            {/* addons */}
            {groupState.add_ons.map((add, i) => (
              <div
                key={add.id}
                className="row align-items-center w-100 gap-3 mb-2"
              >
                <div className="col-md-2">
                  <h2 className="font14">{add.name}</h2>
                </div>
                <div className="col-md-3 ">
                  السعر
                  <input
                    type="number"
                    className="form-control"
                    style={{ width: "120px" }}
                    value={add.price}
                    onChange={(e) =>
                      updateAddon(group.id, add.id, "price", e.target.value)
                    }
                  />
                </div>

                <div className="col-md-3">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={add.is_default == 1}
                      onChange={(e) =>
                        updateAddon(
                          group.id,
                          add.id,
                          "is_default",
                          e.target.checked ? 1 : 0,
                        )
                      }
                    />
                    <label className="form-check-label">افتراضي</label>
                  </div>
                </div>

                <div className="col-md">
                  <input
                    type="checkbox"
                    checked={add.selected}
                    onChange={(e) => toggleAddon(group.id, add.id, "selected", e.target.checked)}
                  />
                </div>
              </div>
            ))}
          </div>
        );
      })}

      <AddsOneModal
        refetch={refetch}
        closeModal={closeModal}
        isOpen={isModalOpen}
        store_id={store_id}
        setSelectedAddOnsGroup={setSelectedAddOnsGroup}
        setGroupsState={setGroupsState}
        product={product}
      />
    </div>
  );
};

export default AddsOne;
